
import {Options, Vue} from 'vue-class-component';
import './../less/references.less'
import Gallery from "@/components/Gallery.vue";
import Accordion from "@/components/Accordion.vue";
import Logo from "@/components/Logo.vue";
import axios from "axios";

@Options({
    components: {
        Gallery,
        Logo,
        Accordion
    },
})
export default class ReferencesPage extends Vue {
    isOpenMenu = false
    isShowGalleryPopup = false
    galleryIndex = 0

    images :any= []

    accordions = [
        {
            title: "Milyen kategóriákban lehet jelölni cégvezetőt/céget?",
            description: "A díjakra történő jelentkezést alapesetben a saját iparágra értelmezzük. Amennyiben az alaptevékenységtől eltérő kategóriában történik a jelölés, azt kérjük a megjegyzés rovatban feltüntetni."
        },
        {
            title: "Egyénileg és céges szinten is lehet jelölni? (Bárkit jelölhetek, vagy van egy lista?)",
            description: "Cégvezetőket és vállalatokat is lehet jelölni, nincs előre meghatározva, hogy ki lehet a jelölt."
        },
        {
            title: "Jelölhetem magamat és/vagy a cégemet?",
            description: "Igen, a cégvezető önmagát és a cégét is tudja jelölni az egyes szakmai, ágazati díjakra."
        },
        {
            title: "Jelölhetem egy időben két díjra is a céget?",
            description: "Természetesen, ezt úgy teheti meg, hogy külön-külön küldi el a jelölést a személyt/céget illetően."
        },
        {
            title: "Milyen formában és hol tudok jelölni?",
            description: "A főoldalon, illetve a Díjak oldalon tud jelölni a megfelelő díjkategória kiválasztásával. Az Üzleti Életműdíjra az Üzleti Életműdíj menüpontban tud ajánlást tenni. (itt rakjatok linkeket kérlek az egyes szavakra)"
        },
        {
            title: "Hogyan történik a díjátadás?",
            description: "Az előzetesen, a honlapunkon meghirdetett exkluzív, ünnepélyes díjátadó keretében."
        }
    ]
    lightBoxGalleryImages :any= [];

    menuToggle() {
        this.isOpenMenu = !this.isOpenMenu
    }

    mounted() {
        document.title = 'HBA - Referenciák / GYIK'
        this.getMediaData()
    }

    getMediaData() {
        axios.get('/api/v1/assets?per_page=1000').then((data) => {
            if (data?.data?.data.length > 0) {
                data.data.data.map((media :any)=>{
                    media.files.map((image : any)=>{
                        this.images.push(image)
                        this.lightBoxGalleryImages.push({src: image.url})

                    })
                })
            }
        })
    }

    showGallery(index: number) {
        this.galleryIndex = index
        this.isShowGalleryPopup = true
        window.addEventListener('keydown', this.handleKeydown);

    }

    handleKeydown(e: any) {
        switch (e.keyCode) {
            case 37:
                this.back();
                break;
            case 39:
                this.next();
                break;
        }
    }

    closeGallery() {
        this.isShowGalleryPopup = false
        window.removeEventListener('keydown', this.handleKeydown);
    }

    back() {
        if (this.galleryIndex != 0) {
            this.galleryIndex--
        }
    }

    next() {
        if (this.galleryIndex != this.images.length - 1) {
            this.galleryIndex++
        }
    }
}
